"use strict";
// packages/shared/src/endpoints.ts
//
// Cross-platform endpoint helpers + shared config exports.
//
// This file supports both:
//   - Web (CRA): REACT_APP_* env vars
//   - Mobile (Expo): EXPO_PUBLIC_* env vars
//
// GraphQL proxy endpoint priority:
//   1) REACT_APP_GRAPHQLPROXY_ENDPOINT            (web build / Node env override)
//   2) EXPO_PUBLIC_GRAPHQL_PROXY_ENDPOINT         (explicit Expo override; takes precedence)
//   3) EXPO_PUBLIC_MOBILE_REGION + (EU/GLOBAL)    (mobile region selection)
//   4) window.location.origin + "/graphql"        (browser fallback; CloudFront → private AppSync)
//   5) hard fallback defaults (global then eu)
Object.defineProperty(exports, "__esModule", { value: true });
exports.enableConfigureAgents = exports.userTable = exports.eventTable = exports.uploadTable = exports.fmHandlerArns = exports.cognitoConfig = exports.privateAgentApiEndpoint = exports.publicAgentApiEndpoint = exports.expoGraphqlProxyGlobal = exports.expoGraphqlProxyEu = exports.expoMobileRegionHint = exports.graphqlProxyEndpoint = exports.GRAPHQL_PROXY_EU_DEFAULT = exports.GRAPHQL_PROXY_GLOBAL_DEFAULT = void 0;
/**
 * Hard defaults. These should be valid in both repos.
 * - Global default: chat.heartcheckapp.com
 * - EU default:     chat.eu.heartcheckapp.com
 */
exports.GRAPHQL_PROXY_GLOBAL_DEFAULT = "https://chat.heartcheckapp.com/graphql";
exports.GRAPHQL_PROXY_EU_DEFAULT = "https://chat.eu.heartcheckapp.com/graphql";
function hasDOM() {
    return typeof window !== "undefined" && typeof document !== "undefined";
}
function pickEnv(name) {
    const raw = process.env[name];
    const trimmed = raw?.trim();
    return trimmed && trimmed.length > 0 ? trimmed : undefined;
}
function normalizeRegion(raw) {
    const v = (raw || "").trim().toLowerCase();
    if (v === "eu")
        return "eu";
    if (v === "global")
        return "global";
    return undefined;
}
function normalizeUrl(raw) {
    if (!raw)
        return undefined;
    const trimmed = raw.trim();
    if (!trimmed)
        return undefined;
    return trimmed.endsWith("/") ? trimmed.slice(0, -1) : trimmed;
}
// ------------------------------
// GraphQL proxy endpoint selection
// ------------------------------
const fromReactEnv = normalizeUrl(pickEnv("REACT_APP_GRAPHQLPROXY_ENDPOINT"));
const fromExpoEnv = normalizeUrl(pickEnv("EXPO_PUBLIC_GRAPHQL_PROXY_ENDPOINT"));
const mobileRegion = normalizeRegion(pickEnv("EXPO_PUBLIC_MOBILE_REGION"));
const mobileEu = normalizeUrl(pickEnv("EXPO_PUBLIC_GRAPHQL_PROXY_EU"));
const mobileGlobal = normalizeUrl(pickEnv("EXPO_PUBLIC_GRAPHQL_PROXY_GLOBAL"));
function pickMobileGraphqlByRegion() {
    if (!mobileRegion)
        return undefined;
    if (mobileRegion === "eu") {
        if (mobileEu)
            return mobileEu;
        if (mobileGlobal)
            return mobileGlobal;
        return exports.GRAPHQL_PROXY_EU_DEFAULT;
    }
    // mobileRegion === "global"
    if (mobileGlobal)
        return mobileGlobal;
    if (mobileEu)
        return mobileEu;
    return exports.GRAPHQL_PROXY_GLOBAL_DEFAULT;
}
let resolvedGraphqlProxyEndpoint;
if (fromReactEnv) {
    resolvedGraphqlProxyEndpoint = fromReactEnv;
}
else if (fromExpoEnv) {
    resolvedGraphqlProxyEndpoint = fromExpoEnv;
}
else {
    const fromRegion = pickMobileGraphqlByRegion();
    if (fromRegion) {
        resolvedGraphqlProxyEndpoint = fromRegion;
    }
    else if (hasDOM()) {
        resolvedGraphqlProxyEndpoint = `${window.location.origin}/graphql`;
    }
    else {
        resolvedGraphqlProxyEndpoint = exports.GRAPHQL_PROXY_GLOBAL_DEFAULT;
    }
}
/**
 * GraphQL proxy endpoint used by GraphqlQuery / invokeGraphqlProxy.
 */
exports.graphqlProxyEndpoint = resolvedGraphqlProxyEndpoint;
/**
 * Helpful exports for mobile invoker debugging / telemetry.
 */
exports.expoMobileRegionHint = mobileRegion;
exports.expoGraphqlProxyEu = mobileEu;
exports.expoGraphqlProxyGlobal = mobileGlobal;
// ------------------------------
// Existing EU repo exports (kept)
// ------------------------------
exports.publicAgentApiEndpoint = process.env
    .REACT_APP_PUBLICAGENTAPIENDPOINT;
exports.privateAgentApiEndpoint = process.env
    .REACT_APP_PRIVATEAGENTAPIENDPOINT;
exports.cognitoConfig = {
    region: process.env.REACT_APP_REGION,
    userPoolId: process.env.REACT_APP_COGNITOPOOL,
    userPoolClientId: process.env.REACT_APP_COGNITOCLIENTAUTH,
    userPoolDomain: process.env.REACT_APP_COGNITODOMAIN,
    userPoolRedirectSignInUri: process.env
        .REACT_APP_COGNITOREDIRECTSIGNINURL,
    userPoolRedirectSignOutUri: process.env
        .REACT_APP_COGNITOREDIRECTSIGNOUTURL,
};
exports.fmHandlerArns = [
    {
        label: "start",
        name: process.env.REACT_APP_HANDLERCLAUDESTART,
    },
    {
        label: "question-and-answer",
        name: process.env.REACT_APP_HANDLERCLAUDEQUESTIONANDANSWER,
    },
];
exports.uploadTable = process.env.REACT_APP_UPLOADSTABLE;
exports.eventTable = process.env.REACT_APP_EVENTSTABLE;
exports.userTable = process.env.REACT_APP_USERSTABLE;
exports.enableConfigureAgents = process.env.REACT_APP_ENABLECONSTRUCTINGAGENTS === "true";
